import IconProps from 'tailwind/components/Icon/Icon.types';

const Icon = ({ children, size, ...forwardProps }: IconProps) => (
  <svg {...forwardProps} fill="none" height={size} width={size}>
    {children}
  </svg>
);

export default Icon;
